<template>
  <v-container>
    <SurveySelect v-if="view === 'select'" />
    <SurveyDetail v-else-if="view === 'detail'" />
  </v-container>
</template>

<script>
import SurveyDetail from './SurveyDetail.vue'
import SurveySelect from './SurveySelect.vue'

export default {
  components: {
    SurveyDetail,
    SurveySelect
  },
  provide() {
    return {
      survey: () => this.survey,
      setSurvey: (value) => (this.survey = value),
      surveyId: () => this.surveyId,
      view: () => this.view,
      setView: (value) => (this.view = value)
    }
  },
  data() {
    return {
      survey: null,
      view: 'select'
    }
  },
  computed: {
    surveyId() {
      if (!this.survey) return null
      return this.survey.id
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/survey/SurveyReport.vue